import { cn } from '@/lib/utils';

export interface LoadingRowsProps {
  label: string;
  /** Number of placeholder cells per row. */
  columns?: number;
  rows?: number;
  className?: string;
}

/**
 * Mirrors `apps/admin-ui/src/components/shared/LoadingRows.tsx`: a live-region
 * label plus skeleton table rows, used while a table query is in flight
 * (design §16.1 — tables never show bare spinners).
 */
export function LoadingRows({ label, columns = 4, rows = 4, className }: LoadingRowsProps) {
  return (
    <div role="status" aria-live="polite" className={cn('space-y-2', className)}>
      <p className="text-sm text-muted-foreground">{label}</p>
      <div className="overflow-hidden rounded-lg border" aria-hidden="true">
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <div
            key={rowIndex}
            className={cn(
              'flex items-center gap-4 px-4 py-3',
              rowIndex > 0 && 'border-t',
              'animate-pulse motion-reduce:animate-none',
            )}
          >
            {Array.from({ length: columns }).map((__, columnIndex) => (
              <div
                key={columnIndex}
                className="h-4 flex-1 rounded-sm bg-muted"
                style={{ maxWidth: columnIndex === 0 ? undefined : '8rem' }}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
